// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2b4wf","container":"styles_container__347-I","title":"styles_title__2cWB7","wrapper":"styles_wrapper__2Bswz","answer":"styles_answer__3pVqi"};